export default {"id":"293c3758","attrs":{"viewBox":"0 0 22 24","width":"22","height":"24"}}